// import Calendar from './index';
export default {
  priority: 95,
  name: app.translate("routes.home.attendance.calendar.Calendar"),
  path: "calendar",
  permissions: ["TimeAttendanceMenu/CalendarMenu"],
  // component: Calendar,
  component: load(() => import(/* webpackChunkName: "Calendar" */ './index')),
  icon: "calendar",
  drawer: true,
};


